(function ($) {
  if ($('.guide-detail').length > 0) {
    $(window).on("load", function () {
      var $guideLink = $('.guide-detail .guide-sidebar .guide-links');
      $guideLink.each(function () {
        var height = $(this).outerHeight(); $(this).attr("data-height", height); $(this).css("height", 0);
        // var first_height = $guideLink.eq(0).attr('data-height'); $guideLink.eq(0).css("height", first_height);
      });
      $('.guide-detail .guide-sidebar .guide-category').addClass("hide");
      $(document).on('click', '.guide-detail .guide-sidebar .guide-category.active', function (e) {
        e.preventDefault();
      });
      $(document).on('click', '.guide-detail .guide-sidebar .guide-category .main-heading', function (e) {
        // var dataID = $(this).parent().parent().attr("data-tab-li");
        // $('body, html').animate({scrollTop: 0});
        // $('.guide-detail .guide-sidebar .guide-category.active').removeClass("active").addClass("hide");
        // $('.guide-detail .content-wrap .content-col-wrap.active').removeClass("active");
        // $(this).parent().parent().addClass("active").removeClass("hide");
        // $('.guide-detail .content-wrap .content-col-wrap[data-tab-li="' + dataID + '"]').addClass("active");
        // $(".redesign-20 .guide-detail .guide-sidebar .guide-links").css({'height': 0});
        // var guideHeight = $(this).parent().parent().find(".guide-links").attr('data-height');
        // $(this).parent().parent().find(".guide-links").css({'height': guideHeight + "px"});
        // var patent_text = $('.guide-detail .guide-sidebar .guide-category.active .main-heading').text();
        // $('.guide-detail .btn-outer .links').empty().append('<p><span> / </span>' + patent_text + '</p>');
      });

      $(".guide-detail .content-wrap .body h1, .guide-detail .content-wrap .body h2, .guide-detail .content-wrap .body h3, .guide-detail .content-wrap .body h4, .guide-detail .content-wrap .body h5, .guide-detail .content-wrap .body h6").each(function () {
        var text = $(this).text().replace(/ /g, '-').toLowerCase();
        var title = $(this).parent().attr("data-title").replace(/ /g, '-').toLowerCase();
        text = text.replace(".", '-');text = text.replace("?", '');text = text.replace(":", '');
        text = text.replace("#", '');text = text.replace(",", '');text = text.replace(/[0-9]+/, '');
        title = title.replace(".", '-');title = title.replace("?", '');title = title.replace(":", '');
        title = title.replace("#", '');title = title.replace(",", '');title = title.replace(/[0-9]+/, '');
        $(this).attr('id', title + "-" + text);
      });

      $(document).on('click', '.guide-detail .guide-sidebar .guide-links li a[href^="#"]', function (e) {
        var id = $(this).attr('href'), $id = $(id);
        if ($id.length === 0) {return;}
        e.preventDefault();
        var pos = $id.offset().top - 70 - 91;
        $('body, html').animate({scrollTop: pos});
      });
      $('.guide-detail').css("opacity", 1);
    });
    $(window).on('load scroll', function () {
      var sticky = $('.guide-detail .sticky'), stickyHeight = sticky.height(), navHeight = $('header').outerHeight();
      sticky.css('height', stickyHeight);sticky.children().css('height', stickyHeight);
      var num = sticky.offset().top - 120;
      if ($(window).scrollTop() > num) {
        sticky.children().css({"position": "fixed", "top": navHeight + "px", "left": "0", "right": "0", "z-index": "999"})
      }
      else { sticky.children().removeAttr("style"); }
    });

    $('.redesign-20 .guide-detail .guide-sidebar .guide-category .guide-tab .main-heading').on("click", function (e) {
      // e.preventDefault();
      // var main_link = $(this).attr("data-link");window.history.pushState('', '', main_link + "/"); stickySideBar();
    });

    var main_link = $('.redesign-20 .guide-detail .guide-sidebar').attr('data-link'),
      item = $(".redesign-20 .guide-detail .guide-sidebar .guide-links li");

    item.each(function () {
      var liText = $(this).text().toLowerCase().replaceAll(" ", "-").replaceAll("?", "");
      $(this).attr('data-id', liText);
    });

    item.on("click", function (e) {
      e.preventDefault();
      var clickedItem = $(this).text().toLowerCase().replaceAll(" ", "-").replaceAll("?", ""),
        clickedItemTitle = $(this).parent().parent().find(".guide-tab .main-heading").text().toLowerCase().replaceAll(" ", "-").replaceAll("?", "");
      window.history.pushState('', '', main_link + "" + clickedItemTitle + "/#" + clickedItem);
    });

    var uri = window.location.href,slash_URL = uri.split("/"),lastName = slash_URL[slash_URL.length - 2],
      hash_URL = uri.split("#");

    $(window).on("load", function () {
      $(".redesign-20 .guide-detail .guide-sidebar .guide-category").removeClass("active").addClass('hide');
      item.removeClass("active");
      var dataID = $('.guide-detail .guide-sidebar .guide-category[data-name="' + lastName + '"]').attr('data-tab-li');
      if (dataID !== undefined) {
        $('.guide-detail .guide-sidebar .guide-category[data-tab-li="' + dataID + '"]').addClass("active").removeClass('hide');
        $('.guide-detail .content-wrap .content-col-wrap[data-tab-li="' + dataID + '"]').addClass("active");
        $('.redesign-20 .guide-detail .guide-sidebar .guide-links li').removeClass("active");
        $('.redesign-20 .guide-detail .guide-sidebar .guide-links li[data-id="' + hash_URL[1] + '"]').addClass("active");
      } else {
        $('.guide-detail .guide-sidebar .guide-category').eq(0).addClass("active").removeClass('hide');
        $('.guide-detail .content-wrap .content-col-wrap').eq(0).addClass("active");
      }
    });

    $(window).on("load", function () {
      setTimeout(function () {
        stickySideBar();
      }, 1000);
      setTimeout(function () {
        var patent_text = $(".guide-detail .guide-sidebar .guide-category.active .guide-tab .main-heading").text();
        $('.guide-detail .btn-outer .links').empty().append('<p><span> / </span>' + patent_text + '</p>');
        var large_height = $('.guide-detail .guide-sidebar .guide-category.active .guide-links').attr('data-height');
        $('.guide-detail .guide-sidebar .guide-category.active .guide-links').css({"height": large_height});
      }, 100);
    });
  }

  function stickySideBar() {
    var $sticky = $('.side-sticky')
    if (!!$sticky.offset()) {
      var $stickyrStopper, stickyStopperPosition, stopPoint, diff, navHeight = $('header').outerHeight(),
        stickyHeight = $('.guide-detail .sticky').outerHeight(), stickOffset = 8,
        finalHeight = navHeight + stickyHeight,
        generalSidebarHeight = $sticky.innerHeight(), stickyTop = $sticky.offset().top - finalHeight;
      $stickyrStopper = $('.guide-detail .content-wrap .content-col-wrap.active .sticky-stopper');
      stickyStopperPosition = $stickyrStopper.offset().top - finalHeight;
      stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset - 50;
      diff = stopPoint + stickOffset - finalHeight + 100;
      $(window).on("scroll resize", function () {
      var $winHeight = $(window).height(), $sideSticky = $sticky.height() +finalHeight;
      if ($winHeight > $sideSticky) {
        var windowTop = $(window).scrollTop();
        if (stopPoint < windowTop) {
          $sticky.removeAttr("style").css({position: 'absolute', top: diff, "left": "0", "right": "0"});
        } else if (stickyTop < windowTop + stickOffset) {
          $sticky.removeAttr("style").css({position: 'fixed', top: "186px", "left": "auto", "right": "auto"});
        } else {
          $sticky.removeAttr("style").css({position: 'absolute', top: '0', "left": "0", "right": "0"});
        }
    }
      });
    }
    $('.guide-detail .guide-sidebar .guide-links li').on('click', function () {
      $(this).addClass("active"); $('.guide-detail .guide-sidebar .guide-links li').not(this).removeClass('active');
    });
  }


})(jQuery);